import { useState, type FormEvent } from 'react'

export interface CustomerFields {
  name: string
  phone: string
  email: string
  address: string
}

/** Stammdaten-Formular, geteilt von Anlegen und Bearbeiten. Der Aufrufer entscheidet, was beim Submit
 *  passiert (POST ohne / PATCH mit `version`). Pflichtfeld ist nur der Name. */
export function CustomerForm({
  initial,
  submitLabel,
  submitting,
  error,
  onSubmit,
  onCancel,
}: {
  initial: CustomerFields
  submitLabel: string
  submitting: boolean
  error: string | null
  onSubmit: (fields: CustomerFields) => void
  onCancel?: () => void
}) {
  const [fields, setFields] = useState(initial)
  const set = (key: keyof CustomerFields) => (event: { target: { value: string } }) =>
    setFields((prev) => ({ ...prev, [key]: event.target.value }))

  function submit(event: FormEvent) {
    event.preventDefault()
    if (!fields.name.trim()) return
    onSubmit({ ...fields, name: fields.name.trim() })
  }

  return (
    <form onSubmit={submit}>
      <div className="two">
        <label className="wf-field">
          <span className="wf-label">Name</span>
          <input className="wf-input" value={fields.name} onChange={set('name')} placeholder="Max Mustermann" />
        </label>
        <label className="wf-field">
          <span className="wf-label">Telefon</span>
          <input className="wf-input" type="tel" value={fields.phone} onChange={set('phone')} placeholder="0123 456789" />
        </label>
      </div>
      <div className="two">
        <label className="wf-field">
          <span className="wf-label">E-Mail</span>
          <input className="wf-input" type="email" value={fields.email} onChange={set('email')} placeholder="name@mail.de" />
        </label>
        <label className="wf-field">
          <span className="wf-label">Anschrift</span>
          <input className="wf-input" value={fields.address} onChange={set('address')} placeholder="Musterstr. 1, 12345 Stadt" />
        </label>
      </div>
      {error ? (
        <p className="error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="wf-listfoot">
        {onCancel ? (
          <button type="button" className="wf-btn wf-btn--ghost" onClick={onCancel}>
            Abbrechen
          </button>
        ) : null}
        <button type="submit" className="wf-btn" disabled={submitting || !fields.name.trim()}>
          {submitLabel}
        </button>
      </div>
    </form>
  )
}
